// extracted by mini-css-extract-plugin
export var body = "_3t-1";
export var bodyPadded = "_3t-2";
export var chevron = "_3t-4";
export var chevronOpen = "_3t-5";
export var header = "_3t-0";
export var icon = "_3t-3";